"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsTimeline = void 0;
var react_1 = __importDefault(require("react"));
require("./Timeline.scss");
var joinClassNames = function () {
    var names = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        names[_i] = arguments[_i];
    }
    return names.filter(Boolean).join(' ');
};
var WsTimeline = function (_a) {
    var points = _a.points, _b = _a.orientation, orientation = _b === void 0 ? 'vertical' : _b, _c = _a.showPointNumbers, showPointNumbers = _c === void 0 ? false : _c, className = _a.className, highlightText = _a.highlightText;
    if (!points || points.length === 0) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        ' ',
        react_1.default.createElement("h2", { className: "ws-ai-hub-prioritisation-title" }, "Process"),
        react_1.default.createElement("section", { className: joinClassNames('ws-ai-hub-timeline', "ws-ai-hub-timeline-" + orientation, className) },
            react_1.default.createElement("span", { className: "ws-ai-hub-timeline-axis", "aria-hidden": "true" }),
            points.map(function (point, index) {
                var isEven = index % 2 === 0;
                var placement = orientation === 'vertical' ? (isEven ? 'left' : 'right') : isEven ? 'top' : 'bottom';
                var hasContent = Boolean(point.header || point.subheader || point.description);
                var pointNumber = point.number !== undefined ? point.number : index + 1;
                return (react_1.default.createElement("article", { key: point.id || "timeline-point-" + index, className: joinClassNames('ws-ai-hub-timeline-item', "ws-ai-hub-timeline-item-" + placement) },
                    react_1.default.createElement("span", { className: joinClassNames('ws-ai-hub-timeline-connector', "ws-ai-hub-timeline-connector-" + placement), "aria-hidden": "true" }),
                    react_1.default.createElement("span", { className: "ws-ai-hub-timeline-dot", "aria-hidden": "true" }, showPointNumbers ? react_1.default.createElement("span", null, pointNumber) : null),
                    hasContent ? (react_1.default.createElement("div", { className: joinClassNames('ws-ai-hub-timeline-content', "ws-ai-hub-timeline-content-" + placement) },
                        point.header ? react_1.default.createElement("h3", null, point.header) : null,
                        point.subheader ? react_1.default.createElement("h4", null, point.subheader) : null,
                        point.description ? (react_1.default.createElement("p", null, highlightText
                            ? highlightText(point.description, "timeline-description-" + (index + 1))
                            : point.description)) : null)) : null));
            }))));
};
exports.WsTimeline = WsTimeline;
